import { useCallback, useMemo } from 'react';

import { UserType } from '@enums/index';
import { Mentee, Mentor } from '@modules/auth/types';

import {
    useLazyGetMenteePersonalProfileQuery,
    useLazyGetMentorPersonalProfileQuery,
} from '../api/personalInfo';

interface PersonalInfoProps {
    userType: UserType;
}

export default function usePeronalInfo({ userType }: PersonalInfoProps) {
    const [getMentorPersonalInfo, { data: mentorPersonalInfo, isLoading: isMentorInfoLoading }] =
        useLazyGetMentorPersonalProfileQuery();

    const [getMenteePersonalInfo, { data: menteePersonalInfo, isLoading: isMenteeInfoLoading }] =
        useLazyGetMenteePersonalProfileQuery();

    const isLoading = useMemo(
        () => isMentorInfoLoading || isMenteeInfoLoading,
        [isMentorInfoLoading, isMenteeInfoLoading]
    );

    const personalProfileInfo = useMemo(
        () => mentorPersonalInfo || menteePersonalInfo,
        [mentorPersonalInfo, menteePersonalInfo]
    ) as Mentor | Mentee;

    const getPersonalInfo = useCallback(
        (username: string) => {
            let personalInfo: Mentee | Mentor;
            switch (userType) {
                case UserType.Mentor:
                    getMentorPersonalInfo({ username });
                    break;
                case UserType.Mentee:
                    getMenteePersonalInfo({ username });
                    break;
                default:
                    break;
            }
            return personalInfo!;
        },
        [getMenteePersonalInfo, getMentorPersonalInfo, userType]
    );
    return {
        getPersonalInfo,
        isLoading,
        personalProfileInfo,
    };
}
